import React from 'react';
import { Box, BoxProps } from '@apia/theme';
import { useFieldSelector } from '../../../../store/validation/validationStore';
import { useFormContext } from '../FormContext';
import ValidationError from './ValidationError';
import RequiredBox from '../../../apia/execution/common/RequiredBox';

export interface IWrapper extends BoxProps {
  name: string;
  label?: string;
  children: React.ReactNode;
  required?: boolean;
  avoidSemicolon?: boolean;
  className?: string;
}

const Wrapper = ({
  name,
  label,
  avoidSemicolon = true,
  children,
  className,
  as = 'label',
  required,
  ...props
}: IWrapper) => {
  const { name: formName } = useFormContext();
  const isRequired = useFieldSelector(
    formName,
    name,
    (global) => global?.validationRules?.required,
  );

  /**
   * Cuando no tiene label, no tiene sentido mostrar más que estos elementos
   */
  if (!label) {
    return (
      <Box className={`fieldWrapper ${className ?? ''}`} {...props} as={as}>
        {children}
        <ValidationError name={name} />
      </Box>
    );
  }

  return (
    <Box className={`fieldWrapper ${className ?? ''}`} {...props} as={as}>
      <Box as="span">
        <RequiredBox
          label={label}
          avoidColon={avoidSemicolon}
          required={required ? required : isRequired}
        />
      </Box>
      {children}
      <ValidationError name={name} />
    </Box>
  );
};

export default React.memo(Wrapper);
